import { useController } from 'react-hook-form';

import { useIntl } from '@zenbusiness/application-commons-intl';

import { buildFieldName } from '#client/utils/form';

import { FIELD_NAMES } from '../../constants';

const MAX_LENGTH = 100;

export default function useAddress1Field({ namePrefix, validation } = {}) {
  const { formatMessage } = useIntl();

  const defaultValidation = {
    required: formatMessage(
      { id: 'shopping.component.addressFieldset.address1Field.error.required' },
      { label: 'Address line 1' }
    ),
    maxLength: {
      message: formatMessage(
        { id: 'shopping.component.addressFieldset.address1Field.error.maxLength' },
        { label: 'Address line 1', maxLength: MAX_LENGTH }
      ),
      value: MAX_LENGTH
    }
  };

  const fieldName = buildFieldName(FIELD_NAMES.ADDRESS_1, namePrefix);

  const {
    field: { onBlur, ...field },
    fieldState: { error }
  } = useController({
    defaultValue: '',
    name: fieldName,
    rules: { ...defaultValidation, ...validation }
  });

  const handleBlur = (e) => {
    field.onChange(e.target.value.trim());
  };

  return {
    error,
    field: {
      ...field,
      value: field.value ?? '',
      onBlur: handleBlur
    }
  };
}
